import PropTypes from 'prop-types';

import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

const noOptionsMessage = ({ inputValue }) =>
  inputValue
    ? __('Degree %{degree} not found').i__({
        degree: inputValue,
      })
    : __('Search for a degree');

const ReactSelectDegrees = ({
  placeholder,
  isMulti,
  multiple,
  ...otherProps
}) => (
  <ReactSelectAsyncWithAxios
    {...otherProps}
    multiple={multiple || isMulti}
    loadOptionsUrl={Routes.search_degrees_path({ format: 'json' })}
    placeholder={placeholder || __('Degree')}
    noOptionsMessage={noOptionsMessage}
  />
);

ReactSelectDegrees.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectDegrees;
